<template>
    <div>
        <el-date-picker
            v-if="pickerOnly"
            :value="value"
            type="daterange"
            placeholder="選擇日期"
            :clearable="false"
            value-format="timestamp"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            :default-time="['00:00:00', '23:59:59']"
            :size="size"
            @input="val => $emit('input', val)"
            @change="$emit('change', value)"
        >
        </el-date-picker>
        <el-form-item v-else :label="label">
            <el-date-picker
                :value="value"
                type="daterange"
                placeholder="選擇日期"
                :clearable="false"
                value-format="timestamp"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
                :default-time="['00:00:00', '23:59:59']"
                @input="val => $emit('input', val)"
                @change="$emit('change', value)"
            >
            </el-date-picker>
        </el-form-item>
    </div>
</template>
<script>
import moment from 'moment';

const TODAY = moment();
const DAY = [TODAY.startOf('day').format('x'), TODAY.endOf('day').format('x')];
const MONTH = [TODAY.startOf('month').format('x'), TODAY.endOf('month').format('x')];
const YEAR = [TODAY.startOf('year').format('x'), TODAY.endOf('year').format('x')];

export default {
    name: 'ah-select-time-range',
    props: {
        label: {
            type: String,
            default: '日期區間',
        },
        default: {
            type: String,
            default: 'today',
        },
        value: {
            type: Array,
            default: () => [null, null],
        },
        pickerOnly: Boolean,
        size: String,
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.default === 'month') this.$emit('input', MONTH);
            else if (this.default === 'year') this.$emit('input', YEAR);
            else this.$emit('input', DAY);
        },
    },
};
</script>
